/* tslint:disable */
/* eslint-disable */
/**
 * Pfa API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PersonRegisterDto
 */
export interface PersonRegisterDto {
    /**
     * 
     * @type {string}
     * @memberof PersonRegisterDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonRegisterDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonRegisterDto
     */
    membershipName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonRegisterDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonRegisterDto
     */
    phoneNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonRegisterDto
     */
    street?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonRegisterDto
     */
    city?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PersonRegisterDto
     */
    membershipNo?: number;
    /**
     * 
     * @type {string}
     * @memberof PersonRegisterDto
     */
    country?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonRegisterDto
     */
    zipCode?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof PersonRegisterDto
     */
    birthday?: Date;
    /**
     * 
     * @type {Date}
     * @memberof PersonRegisterDto
     */
    registerDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof PersonRegisterDto
     */
    remark?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PersonRegisterDto
     */
    igvKennung?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof PersonRegisterDto
     */
    leisureStatus?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof PersonRegisterDto
     */
    countryId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PersonRegisterDto
     */
    gender?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonRegisterDto
     */
    bankAccountIBAN?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonRegisterDto
     */
    bankOwner?: string | null;
}

/**
 * Check if a given object implements the PersonRegisterDto interface.
 */
export function instanceOfPersonRegisterDto(value: object): value is PersonRegisterDto {
    return true;
}

export function PersonRegisterDtoFromJSON(json: any): PersonRegisterDto {
    return PersonRegisterDtoFromJSONTyped(json, false);
}

export function PersonRegisterDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonRegisterDto {
    if (json == null) {
        return json;
    }
    return {
        
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'email': json['email'] == null ? undefined : json['email'],
        'membershipName': json['membershipName'] == null ? undefined : json['membershipName'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'street': json['street'] == null ? undefined : json['street'],
        'city': json['city'] == null ? undefined : json['city'],
        'membershipNo': json['membershipNo'] == null ? undefined : json['membershipNo'],
        'country': json['country'] == null ? undefined : json['country'],
        'zipCode': json['zipCode'] == null ? undefined : json['zipCode'],
        'birthday': json['birthday'] == null ? undefined : (new Date(json['birthday'])),
        'registerDate': json['registerDate'] == null ? undefined : (new Date(json['registerDate'])),
        'remark': json['remark'] == null ? undefined : json['remark'],
        'igvKennung': json['igvKennung'] == null ? undefined : json['igvKennung'],
        'leisureStatus': json['leisureStatus'] == null ? undefined : json['leisureStatus'],
        'countryId': json['countryId'] == null ? undefined : json['countryId'],
        'gender': json['gender'] == null ? undefined : json['gender'],
        'bankAccountIBAN': json['bankAccountIBAN'] == null ? undefined : json['bankAccountIBAN'],
        'bankOwner': json['bankOwner'] == null ? undefined : json['bankOwner'],
    };
}

export function PersonRegisterDtoToJSON(json: any): PersonRegisterDto {
    return PersonRegisterDtoToJSONTyped(json, false);
}

export function PersonRegisterDtoToJSONTyped(value?: PersonRegisterDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lastName': value['lastName'],
        'email': value['email'],
        'membershipName': value['membershipName'],
        'firstName': value['firstName'],
        'phoneNumber': value['phoneNumber'],
        'street': value['street'],
        'city': value['city'],
        'membershipNo': value['membershipNo'],
        'country': value['country'],
        'zipCode': value['zipCode'],
        'birthday': value['birthday'] == null ? undefined : (() => { const d = value['birthday']; return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}` })(),
        'registerDate': value['registerDate'] == null ? undefined : ((value['registerDate']).toISOString()),
        'remark': value['remark'],
        'igvKennung': value['igvKennung'],
        'leisureStatus': value['leisureStatus'],
        'countryId': value['countryId'],
        'gender': value['gender'],
        'bankAccountIBAN': value['bankAccountIBAN'],
        'bankOwner': value['bankOwner'],
    };
}

